module.exports = __webpack_public_path__ + "img/hohlsaum_himmelblau_ral5015.6203218b.jpg";